import { render, staticRenderFns } from "./AssessmentList.vue?vue&type=template&id=a2dc4262&scoped=true"
import script from "./AssessmentList.vue?vue&type=script&lang=js"
export * from "./AssessmentList.vue?vue&type=script&lang=js"
import style0 from "./AssessmentList.vue?vue&type=style&index=0&id=a2dc4262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc4262",
  null
  
)

export default component.exports